import { render, staticRenderFns } from "./UploadImg.vue?vue&type=template&id=f19604c0&scoped=true"
import script from "./UploadImg.vue?vue&type=script&lang=js"
export * from "./UploadImg.vue?vue&type=script&lang=js"
import style0 from "./UploadImg.vue?vue&type=style&index=0&id=f19604c0&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f19604c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\moyongpeng-project\\tianyi-crm\\scrm-vue\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f19604c0')) {
      api.createRecord('f19604c0', component.options)
    } else {
      api.reload('f19604c0', component.options)
    }
    module.hot.accept("./UploadImg.vue?vue&type=template&id=f19604c0&scoped=true", function () {
      api.rerender('f19604c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/UploadFile/UploadImg.vue"
export default component.exports